export { default } from './divider';
